<h1 mat-dialog-title class="p-2 text-center">Calibration Oxygène</h1>
<div class="p-3">
    <div class="col">
        <div class="row ">
            <!-- <mat-form-field class="col-6">
                <mat-label>SamplerPuid</mat-label>
                <input matInput placeholder="Sampler Puid" [(ngModel)]="model.SamplerPuid">
            </mat-form-field> -->

            <mat-form-field class="col-12 col-md">
                <mat-label>Date </mat-label>
                <input matInput placeholder="Date d'analyse" [matDatepicker]="picker" [(ngModel)]="model.Date" (focus)="picker.open()">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-12 col-md">
                <mat-label>Heure</mat-label>
                <input matInput placeholder="Heure" [ngxTimepicker]="timepicker" [value]="interventionTime" [format]="24" readonly>
                <ngx-material-timepicker #timepicker (timeSet)="timeSet($event)"></ngx-material-timepicker>
            </mat-form-field>
        </div>

        <div class="row align-items-center justify-content-center">
            <mat-form-field class="col-12 col-md">
                <mat-label>Pente</mat-label>
                <input matInput placeholder="Pente" type="number" [(ngModel)]="model.AjustageOxygene.Pente">
            </mat-form-field>

            <mat-form-field class="col-12 col-md">
                <mat-label>Pression (hPa)</mat-label>
                <input matInput placeholder="Pression (hPa)" type="number" [(ngModel)]="model.AjustageOxygene.Pression">
            </mat-form-field>

            <mat-form-field class="col-12 col-md">
                <mat-label>Saturation (%)</mat-label>
                <input matInput placeholder="Saturation (%)" type="number" [(ngModel)]="model.AjustageOxygene.Saturation">
            </mat-form-field>

            <div class="col-auto">
                <mat-icon style="color: darkgreen;" *ngIf="model.AjustageOxygene.Conforme">task_alt</mat-icon>
                <mat-icon style="color: red;" *ngIf="!model.AjustageOxygene.Conforme">task_alt</mat-icon>
            </div>
        </div>
        <div class="row">
            <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()">
                Annuler<mat-icon>undo</mat-icon>
            </button>
        </div>
        <div class="row">
            <button class="col mx-3 my-1" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="primary" (throttledClick)="onConfirm()" [disabled]="!CanAddNewMeasure()">
                Sauvegarder<mat-icon>save</mat-icon>
            </button>
        </div>
    </div>
</div>